import { SnackbarProviderProps } from "notistack";
import { Snackbar } from "~/components/Snackbar";

export const SnackbarComponents: SnackbarProviderProps["Components"] = {
  success: Snackbar,
  error: Snackbar,
  warning: Snackbar,
  info: Snackbar,
};
